import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CartActions } from '@spartacus/cart/base/core';
import {
  GlobalMessageService,
  GlobalMessageType,
  LoggerService
} from '@spartacus/core';
import { tap } from 'rxjs/operators';

@Injectable()
export class CustomCartEntryEffects {

  protected logger = inject(LoggerService);
  protected globalMessageService = inject(GlobalMessageService, {
    optional: true,
  });

  /*
  * Removes the confirmation message after a cart entry is successfully removed.
  */
  removeEntrySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CartActions.CART_REMOVE_ENTRY_SUCCESS),
        tap(() => {
          this.globalMessageService.remove(
            GlobalMessageType.MSG_TYPE_CONFIRMATION
          );
        })
      ),
    {
      // No action is dispatched because this effect only performs a UI side effect.
      dispatch: false,
    }
  );

  constructor (private actions$: Actions) {}
}
